module.exports = __webpack_public_path__ + "static/media/speech_22.c7f5a00d.svg";